// extracted by mini-css-extract-plugin
export default {"device-image-container":"device-image-container__N1dFk"};